import { render, staticRenderFns } from "./ProfilePersonal.view.vue?vue&type=template&id=51d352d7&"
import script from "./ProfilePersonal.view.vue?vue&type=script&lang=js&"
export * from "./ProfilePersonal.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports